import { Component } from '@angular/core';

@Component({
  selector: 'mav-cancel-icon',
  templateUrl: './cancel-icon.component.html',
  styleUrls: ['./cancel-icon.component.scss']
})
export class CancelIconComponent {

  constructor() { }
}
